import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { AppConfirmService } from 'src/app/shared/services/app-confirm/app-confirm.service';

@Component({
  selector: 'app-screen-recorder-review-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule, MatTooltipModule],
  template: `
    <div class="standard-dialog">
      <div class="header" mat-dialog-title>
        <div class="title-section">
          <h2>{{ 'ScreenRecorder.Review.Title' | translate }}</h2>
          <p class="subtitle">{{ 'ScreenRecorder.Review.Subtitle' | translate }}</p>
        </div>
        <button mat-icon-button (click)="discard()" class="close-btn">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="form-content">
        <div class="bg-black rounded-lg overflow-hidden flex items-center justify-center min-h-[300px] max-h-[65vh] w-full">
          <video class="w-full max-h-[65vh] object-contain" [src]="videoUrl" controls playsinline></video>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="footer">
        <div class="right-actions ml-auto flex items-center gap-2">
          <button mat-button (click)="discard()">
            {{ 'ScreenRecorder.Review.Discard' | translate }}
          </button>
          <button mat-button btnType="action" (click)="save()">
            {{ 'ScreenRecorder.Review.Save' | translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreenRecorderReviewDialogComponent {
  private dialogRef = inject(MatDialogRef<ScreenRecorderReviewDialogComponent>);
  private sanitizer = inject(DomSanitizer);
  private confirmService = inject(AppConfirmService);
  private translate = inject(TranslateService);
  public data: Blob = inject(MAT_DIALOG_DATA);

  videoUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.data));

  save(): void {
    this.dialogRef.close('save');
  }

  async discard(): Promise<void> {
    const confirmation = await firstValueFrom(
      this.confirmService.confirm({
        message: this.translate.instant('ScreenRecorder.ConfirmDiscard'),
      })
    );

    if (confirmation === 1) {
      this.dialogRef.close('discard');
    }
  }
}
